var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.link}},[_c('div',{staticClass:"bouton openSans font-bold white dashed-space-all"},[_c('i',{staticClass:"fas fa-arrow-right"})])])}
var staticRenderFns = []

export { render, staticRenderFns }